import React, { useContext, useEffect, useState } from 'react'
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { Popover } from '@material-ui/core'
import myContext from '../../FiltersComponent/context/context'
import getSearchResult from '../../Utility/GetSearchResult/GetSearchResult';
import { ListingColumns, SalesColumns, LoanMaturitiesColumns, RentColumns, ProspectingColumns } from './ExportPropertySearchColumns'
import { getFormattedNumber } from '../../../PropertyList/Utility/PropertyListUtility';
import { formatDate } from '../../Utility/Utility';

const ExportSearchButton = () => {

  const [exportClicked, setExportClicked] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [template, setTemplate] = useState(null)
  const { searchCriteria } = useContext(myContext)

  const handleExportSearch = async () => {

    let tempSearchCriteria = { ...searchCriteria, pagination: { from: 0, size: 1000 } }
    const searchResult = new getSearchResult(tempSearchCriteria, function () { })

    const getRow = (selectedTemplateColumns, data) => {
      let row = ""
      row = selectedTemplateColumns.map(columnFormat => formatValues(columnFormat, data))
      return row
    }

    const formatValues = (row, data) => {
      let value = data[row.fieldName] || ''
      value = value.toString()
      // value = value && value.includes(',') ? `\"${value}\"` : value
      value = value && value.trim()
      let column = row.label

      let returnVal = value || ''
      let type = row.type
      let decimalFormat = row.decimalFormat
      switch (type) {
        case 'date':
          returnVal = returnVal && formatDate(returnVal)
          break
        case 'number':
          if (decimalFormat === "0" && returnVal.includes('.')) {
            returnVal = returnVal.substring(0, returnVal.indexOf('.'))
          }
          returnVal = returnVal.includes('.') ? getFormattedNumber(returnVal, '', '2', '2') : getFormattedNumber(returnVal)
          break
        case 'percent':
          returnVal = getFormattedNumber(returnVal, '%')
          break
        case 'currency':
          if (decimalFormat === "0" && returnVal.includes('.')) {
            returnVal = returnVal.substring(0, returnVal.indexOf('.'))
          }
          returnVal = returnVal.includes('.') ? getFormattedNumber(returnVal, '$', '2', '2') : getFormattedNumber(returnVal, '$')
          break
        default: break
      }
      returnVal = returnVal && returnVal.includes(',') ? `\"${returnVal}\"` : returnVal
      if (returnVal === "-") {
        returnVal = ""
      }
      return returnVal
    }

    const response = await searchResult.fetchSearchResultForExport()

    let selectedTemplateColumns = ProspectingColumns

    switch (template) {
      case 'listing':
        selectedTemplateColumns = ListingColumns
        break;

      case 'sales':
        selectedTemplateColumns = SalesColumns
        break;

      case 'rent':
        selectedTemplateColumns = RentColumns
        break;

      case 'loanmaturities':
        selectedTemplateColumns = LoanMaturitiesColumns
        break;

      default:
        selectedTemplateColumns = ProspectingColumns
        break;
    }

    // let selectedTemplateColumns = template === "listing" ? ListingColumns : (template === "sales" ? SalesColumns : (template === "rent" ? RentColumns : LoanMaturitiesColumns))
    let csvData = ""
    csvData += selectedTemplateColumns.map(obj => obj.label).join(',');
    csvData += "\n";
    response.data.data.map(data => {
      let row = getRow(selectedTemplateColumns, data)
      csvData += row.join(',');
      csvData += "\n";
    })

    var blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${template}_propertySearch.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    setExportClicked(false)
    setAnchorEl(null)
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  // useEffect(() => {
  //   if (exportClicked) {
  //     handleGetCompsReport()
  //   }
  // }, [exportClicked])

  const open = Boolean(anchorEl)
  const handleGetCompsReport = (event) => {
    setExportClicked(true)
    event.preventDefault()
    handleExportSearch()
  }

  return (
    <>
      <button onClick={handleClick} data-testid="test-button-export-propertySearch" className="ml-5 py-2 btn btn-sm" >
        <span ><SaveAltIcon className="mr-3" fontSize="small" />Export</span>
      </button>
      <Popover open={open} anchorEl={anchorEl} onClose={handleClose}
        PaperProps={{
          style: { width: '400px', height: '260px' },
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }} >
        <div className="" >
          <div data-testid="test-export-report-label" className="font-semibold pt-4 pb-4 px-6 py-4 border-b-1 border-base">
            <SaveAltIcon /> Export
          </div>
          <div className="flex flex-col pt-4 pb-4 px-6 py-4 border-b-1 border-base">
            <div className="py-4">Template : </div>
            <div className="flex flex-wrap gap-4">
              <span data-testid="test_template_listing" onClick={() => setTemplate("listing")} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${template === "listing" ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                Listing
              </span>
              <span data-testid="test_template_sales" onClick={() => setTemplate("sales")} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${template === "sales" ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                Sales
              </span>
              <span data-testid="test_template_loanmaturities" onClick={() => setTemplate("loanmaturities")} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${template === "loanmaturities" ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                Loan Maturities
              </span>
              <span data-testid="test_template_rent" onClick={() => setTemplate("rent")} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${template === "rent" ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                Rent
              </span>
              <span data-testid="test_template_prospecting" onClick={() => setTemplate("prospecting")} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${template === "prospecting" ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                Prospecting
              </span>
            </div>
          </div>
          <div className="flex justify-end px-6 py-4 space-x-4 mt-auto items-center">
            <div className="">
              {exportClicked ?
                <button data-testid="test-export-search-results-loading" style={{ 'bottom': '10px', 'right': '10px' }} className="btn btn-sm btn-primary c-disabled absolute">
                  <span className="loader h-5 w-5 mx-2" ></span>
                  <span className="px-2">Export</span>
                </button>
                :
                <button disabled={!template} style={{ 'bottom': '10px', 'right': '10px' }} data-testid="test-export-search-results" className="btn btn-sm rounded px-5 absolute btn-primary"
                  onClick={(event) => handleGetCompsReport(event)}>Export</button>
              }

            </div>
          </div>
        </div>
      </Popover>
    </>
  )
}

export default ExportSearchButton
